/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Previous_MarkerInputs */



/**
* | output |
* | --- |
* | "Go to previous marker" |
*
* @param {Shortcut_Keys_Desc_Previous_MarkerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_previous_marker = /** @type {((inputs?: Shortcut_Keys_Desc_Previous_MarkerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Previous_MarkerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aller au marqueur precedent")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zum vorherigen Marker gehen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vai al marcatore precedente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перейти к предыдущей отметке")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ir al marcador anterior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("返回上一个标记")
	if (locale === "ja") return /** @type {LocalizedString} */ ("前のマーカーへ移動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पिछले मार्कर पर जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Voltar ao marcador anterior")
	return /** @type {LocalizedString} */ ("Go to previous marker")
});